// extracted by mini-css-extract-plugin
module.exports = {"contactlinks":"contactlinks-module--contactlinks--2o73P","list":"contactlinks-module--list--1uu14","anchor":"contactlinks-module--anchor--Otks1"};